var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nullPageModule"},[_c('img',{attrs:{"src":require("../assets//image/null.webp"),"alt":""}}),_c('h2',[_vm._v("正在开发中~")])])}]

export { render, staticRenderFns }